export enum WhatsAppTemplateDrawerStatusEnum {
  createWhatsAppTemplate = 'CREATE_WHATSAPP_TEMPLATE',
  preview = 'PREVIEW',
  templateDetails = 'TEMPLATE_DETAILS',
}
